import axios from "axios";
import watch from "../../models/gestionEmpleados/empleados/watch";
import watchesEmp from "../../models/gestionEmpleados/empleados/watchesEmp";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getWatches() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/relojes`, { headers })
      .then(({ data }) => data.map((item) => watch.fromJson(item)));
  }

  getWatchesAsign() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let empId = parseInt(localStorage.getItem("empId"), 10);
    return axios
      .get(`${url}/empleados/relojes/${empId}`, { headers })
      .then(({ data }) => data.map((item) => watchesEmp.fromJson(item)));
  }

  newWatch(data) {
    let token = localStorage.getItem("token");
    let empId = parseInt(localStorage.getItem("empId"), 10);
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      empId: empId,
      fecDesde: data.from + "T00:00:00.000Z",
      relojes: data.relojes,
    };
    if (data.hasOwnProperty("to")) {
      payload.fecHasta =
        moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    return axios.post(`${url}/empleados/relojes`, payload, { headers });
  }

  deleteWatch(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/empleados/relojes/${data.empId}&${data.relojId}&${data.fecDesde}`,
      {
        headers,
      }
    );
  }

  edit(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let empId = localStorage.getItem("empId");
    let payload = {
      haNoEx: data.haNoEx,
    };

    if (data.hasOwnProperty("from")) {
      payload.fecDesde = data.from + "T00:00:00.000Z";
    }

    if (data.hasOwnProperty("to")) {
      payload.fecHasta =
        moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }

    return axios
      .patch(
        `${url}/empleados/relojes/${empId}&${data.relojId}&${data.oldFrom}`,
        payload,
        { headers }
      )
      .then(() => {});
  }
}
export default service;
